import {
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  Divider,
} from "@material-ui/core";
import { FactorMeta } from "../../pages/company-reputation-score/types";

export const FactorCard: React.FC<{
  name: string;
  meta: FactorMeta;
}> = ({ name, meta }) => {
  return (
    <Card
      elevation={3}
      style={{
        borderRadius: 14,
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
    >
      <CardContent style={{ padding: 20 }}>
        {/* Title */}
        <Typography
          variant="subtitle1"
          style={{
            fontWeight: 700,
            letterSpacing: 0.4,
          }}
        >
          {name.replace(/_/g, " ").toUpperCase()}
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          style={{
            marginTop: 6,
            color: "#616161",
          }}
        >
          {meta.description}
        </Typography>

        {/* Metadata chips */}
        <Box
          display="flex"
          flexWrap="wrap"
          style={{gap:8}}
          mt={2}
        >
          <Chip
            size="small"
            label={`Min: ${meta.min_value}`}
            style={{ backgroundColor: "#ECEFF1" }}
          />
          <Chip
            size="small"
            label={`Max: ${meta.max_value}`}
            style={{ backgroundColor: "#E3F2FD" }}
          />
          <Chip
            size="small"
            label={`Weight: ${meta.weightage}`}
            style={{ backgroundColor: "#E8F5E9" }}
          />
        </Box>

        <Divider style={{ margin: "16px 0" }} />

        {/* Formula */}
        <Typography
          variant="caption"
          style={{
            fontWeight: 600,
            color: "#757575",
          }}
        >
          Formula
        </Typography>

        <Box
          mt={1}
          p={1.5}
          style={{
            backgroundColor: "#F5F7FA",
            borderRadius: 8,
            fontFamily: "monospace",
          }}
        >
          <Typography variant="body2">
            {meta.formula}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
